import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { Page } from '@monorepo/base/src/components/page/page';
import pageStyles from '../../styles/pages.module.scss';
import { NotificationsCenterPage } from '../../modules/components/notifications-center-page/notifications-center-page';

export const NotificationsPage: FC = () => {
	return (
		<Page unstyled={true} className={pageStyles.article}>
			<Helmet>
				<title>Manifesto - Notification Center</title>
			</Helmet>
			<NotificationsCenterPage />
		</Page>
	);
};
